import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';

import { Button } from 'primeng/button';

import { BannerNotice, SummitDisposing } from '@summit/models';
import { map, Observable } from 'rxjs';
import { SummitNotificationService } from '../../s-notification.service';

@Component({
  selector: 'summit-notification-banner',
  templateUrl: './notification-banner.component.html',
  styleUrls: ['./notification-banner.component.scss'],
  standalone: true,
  imports: [Button, RouterModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SummitNotificationBannerComponent extends SummitDisposing {
  banner$: Observable<BannerNotice | undefined> = this.notificationService.banner$.pipe(
    map((x) => {
      if (x) {
        if (!x.bannerClass || x.bannerClass === '') x.bannerClass = 'alert-ebo';
        x.bannerClass += ' notification-banner';
      }
      if (x?.routerLink) {
        const root = Array.isArray(x.routerLink) ? x.routerLink : [x.routerLink];
        const targetUrl = this.router.createUrlTree(root, { queryParams: x.queryParams });
        if (targetUrl.toString() == this.router.url.toString()) return undefined;
      }
      return x;
    })
    // tap((x) => console.log('banner', x))
  );
  style = 'background: #64dd17';

  constructor(
    private notificationService: SummitNotificationService,
    private router: Router
  ) {
    super();
    //scroll back to top when a banner appears
    // this.banner$.pipe(pairwise(), takeUntil(this.disposing$)).subscribe(([prior, current]) => {
    //   if (!prior && current) window.scrollTo(0, 0);
    // });
  }

  onClick(notice: BannerNotice) {
    if (notice.onClick) {
      notice.onClick();
    } else if (notice.routerLink) {
      const link = Array.isArray(notice.routerLink) ? notice.routerLink : [notice.routerLink];
      this.router.navigate(link, { queryParams: notice.queryParams });
    }
  }
}
